import React, { useEffect, useState } from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import TopPage from 'v2/components/Shared/TopPage';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { partnerCommissionsService } from 'v2/services/reports/partnerCommissions';

import { Details } from './Details';
import { DetailsModal } from './DetailsModal';
import { Filter } from './Filter';
import { Table } from './Table';

export const PartnerCommissions = () => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const [isLoadingAccount] = useObservable(() => eduzzAccountsService.getLoadingAccount(), []);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [requestPartnerCommissionsDetails] = useCallbackObservable(
    partnerId => partnerCommissionsService.requestPartnerCommissionsDetails(partnerId),
    []
  );

  useEffect(() => {
    return () => partnerCommissionsService.cleanFilter();
  }, []);

  if (isLoadingAccount || !user) return null;

  const handleSeeDetailsClick = (partnerId: number) => {
    requestPartnerCommissionsDetails(partnerId);
    setIsDetailsModalOpen(true);
  };

  const closeDetailsModal = () => setIsDetailsModalOpen(false);

  return (
    <>
      <TopPage
        title='Comissões Pagas a Parceiros'
        extra='Verifique quanto você já pagou de comissão a seus parceiros (coprodutores).'
        disableAlerts
      />

      <Filter />
      <Details />
      <DetailsModal isOpen={isDetailsModalOpen} handleClose={closeDetailsModal} />
      <Table handleSeeDetailsClick={handleSeeDetailsClick} />
    </>
  );
};
